import React from "react";
import { useForm, Controller } from "react-hook-form";
import YFinput from "../elements/YFInput";
import { useApiCall } from "../../api/apiCallHook";
import { submitNumberOfCarRequire } from "../../api";
import { Row, Col, Alert, Select } from "antd";
import Loading from "../../components/Loading";

const { Option } = Select;

const SolutionForBusinessForm = () => {
  const { handleSubmit, register, errors, control } = useForm();
  const onSubmit = (value) => {
    execute({ request: value });
  };

  const { execute, pending, value, error } = useApiCall(
    submitNumberOfCarRequire,
    false
  );

  return (
    <form
      test_id="solution_for_business_form"
      className="solutionForBusinessFormContainer"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
          className="horizontal-container-element"
        >
          <YFinput
            test_id="solution_for_business_form_name"
            name="name"
            type="text"
            label="Name"
            placeholder="Enter Name"
            register={register({ required: true })}
          />
          <div className="form-error">
            {/* {errors.name && <span>Name Required</span>}
             */}
            {/* {errors.name && <Alert type="error" showIcon message="Name Required" />} */}
            {errors.name && (
              <span className="formFieldError">Please enter your name.</span>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
          className="horizontal-container-element"
        >
          <YFinput
            test_id="solution_for_business_form_email"
            name="email"
            type="email"
            label="Email"
            placeholder="Enter Email"
            register={register({
              required: true,
              pattern:
                /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            })}
          />
          {/* <div className="form-error"> */}
          {/* {errors.email?.type === 'required' && <Alert type="error" showIcon message="Email Required" />} */}
          {/* {errors.email?.type === 'pattern' && <Alert type="error" showIcon message="Invalid email format." />} */}
          {errors.email?.type === "required" && (
            <span className="formFieldError">
              Please enter your email address.
            </span>
          )}
          {errors.email?.type === "pattern" && (
            <span className="formFieldError">Invalid email format.</span>
          )}
          {/* </div> */}
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
          className="horizontal-container-element"
        >
          <YFinput
            test_id="solution_for_business_form_contact_number"
            name="contact_number"
            type="number"
            label="Phone Number"
            placeholder="Enter Phone number"
            register={register({ required: true })}
          />
          {/* {errors.contact_number && <Alert type="error" showIcon message="Phone Number Required" />} */}
          {errors.contact_number && (
            <span className="formFieldError">Please enter your phone.</span>
          )}
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
          className="horizontal-container-element"
        >
          <YFinput
            test_id="solution_for_business_form_company_name"
            name="company_name"
            type="text"
            label="Company name"
            placeholder="Enter Company Name"
            register={register({ required: true })}
          />
          {/* {errors.company_name && <Alert type="error" showIcon message="Company Name Required" />} */}
          {errors.company_name && (
            <span className="formFieldError">
              Please enter your company name.
            </span>
          )}
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
          className="horizontal-container-element"
        >
          <YFinput
            test_id="solution_for_business_form_industry"
            name="industry"
            type="text"
            label="Industry"
            placeholder="Enter Industry"
            register={register({ required: true })}
          />
          {/* {errors.industry && <Alert type="error" showIcon message="Industry Required" />} */}
          {errors.industry && (
            <span className="formFieldError">Please enter your industry.</span>
          )}
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
          className="horizontal-container-element"
        >
          <label> Number of car require</label>
          <Controller
            name="no_car_require"
            as={
              <Select
                id="no_car_require"
                className="yf-select"
                style={{ width: "100%" }}
                placeholder="Select car require"
                size="large"
              >
                {number_of_car.map((item) => {
                  return (
                    <Option value={item.value} key={item.id}>
                      {item.label}
                    </Option>
                  );
                })}
              </Select>
            }
            control={control}
            onChange={([selected]) => {
              return selected;
            }}
            rules={{ required: true }}
          />
          <div className="form-error">
            {/* {errors.no_car_require && <Alert type="error" showIcon message="Select number of car required." />} */}
            {errors.no_car_require && (
              <span className="formFieldError">
                Please select the number of car.
              </span>
            )}
          </div>
        </Col>
      </Row>
      <div>
        {value !== null && <Alert type="success" message={value.message} />}
        {error !== null && (
          <Alert type="error" message={error.response.data.errors?.email[0]} />
        )}
        {pending ? (
          <Loading />
        ) : (
          <input
            test_id="solution_for_business_form_submit"
            type="submit"
            label="Submit"
          />
        )}
      </div>
    </form>
  );
};

export default SolutionForBusinessForm;

const number_of_car = [
  { label: "2 to 5", value: "2 to 5" },
  { label: "6 to 10", value: "6 to 10" },
  { label: "11 to 20", value: "11 to 20" },
  { label: "21 and more", value: "21 and more" },
];
